import { portalTypes } from '@/constants'
import { getCustomDomain } from '@/helpers/customDomain/customDomain'
import routes from '@/Router/routes.constants'

export const getBackLinkByPathName = ({ location, orderInfo, merchantInfo, orderRecovery }) => {
  const isCancelationPortal = [portalTypes.cancellations, portalTypes.returnToSender].includes(
    merchantInfo?.preferences?.portal_type
  )
  const backLinkByPathName = {
    [routes.productSelectionPage]: () => {
      const customDomain = getCustomDomain()

      if (orderRecovery?.token) {
        return customDomain ? routes.recoveredOrdersPage : `/${merchantInfo.slug}${routes.recoveredOrdersPage}`
      }

      const encodedOrderNumber = encodeURIComponent(orderInfo.orderNumber)
      const encodedIdentifier = encodeURIComponent(orderInfo.identifier)
      if (customDomain) {
        return `/?orderNumber=${encodedOrderNumber}&identifier=${encodedIdentifier}`
      } else {
        return `/${merchantInfo.slug}/?orderNumber=${encodedOrderNumber}&identifier=${encodedIdentifier}`
      }
    },
    ['/product-detail/']: () => {
      return routes.productSelectionPage
    },
    [routes.deliveryMethodsPage]: () => {
      return routes.productSelectionPage
    },
    [routes.exchangeAddressPage]: () => {
      return routes.deliveryMethodsPage
    },
    [routes.refundSelectionPage]: () => {
      if (isCancelationPortal) {
        return routes.productSelectionPage
      } else {
        return location.state?.from?.pathname || routes.deliveryMethodsPage
      }
    },
    [routes.verifyEmailPage]: () => {
      return location.state?.from?.pathname || routes.deliveryMethodsPage
    },
    [routes.summaryPage]: () => {
      const defaultBackLink = isCancelationPortal ? routes.refundSelectionPage : routes.deliveryMethodsPage

      return location.state?.from?.pathname || defaultBackLink
    },

    [routes.processCompletedPage]: () => null,
  }

  for (const key in backLinkByPathName) {
    if (location.pathname.includes(key)) {
      return backLinkByPathName[key]()
    }
  }
}

const getSummaryStep = ({ orderType, isRefundStepSkipped }) => {
  if (!isRefundStepSkipped) return 3

  return orderType === 'exchange' ? 3 : 2
}

export const getActiveStepByPathName = ({
  pathName,
  orderType,
  portalType,
  orderId,
  returnId,
  isRefundStepSkipped,
}) => {
  const cancellationsPortalSteps = {
    [routes.productSelectionPage]: 0,
    ['/product-detail/']: 0,
    [routes.refundSelectionPage]: 1,
    [routes.summaryPage]: isRefundStepSkipped ? 1 : 2,
    [routes.processCompletedPage]: null,
  }

  const returnAndExchangePortalSteps = {
    [routes.productSelectionPage]: 0,

    ['/product-detail/']: 0,
    [routes.deliveryMethodsPage]: orderType === 'exchange' ? 2 : 1,
    [routes.exchangeAddressPage]: orderType === 'exchange' ? 2 : 1,
    [routes.refundSelectionPage]: orderType === 'exchange' ? 3 : 2,
    [routes.verifyEmailPage]: 2,
    [routes.summaryPage]: getSummaryStep({ orderType, isRefundStepSkipped }),
    [routes.processCompletedPage]: null,
    [routes.successPage.replace(':orderId', orderId).replace(':returnId', returnId)]: null,
  }

  const activeStepsByPathName = [portalTypes.cancellations, portalTypes.returnToSender].includes(portalType)
    ? cancellationsPortalSteps
    : returnAndExchangePortalSteps

  for (const key in activeStepsByPathName) {
    if (pathName.includes(key)) {
      return activeStepsByPathName[key]
    }
  }
}

export const getCardTitleByPathName = ({ pathName, orderId, returnId }) => {
  const cardTitleByPathName = {
    [routes.productSelectionPage]: `Productos`,

    ['/product-detail/']: 'Selección',
    [routes.deliveryMethodsPage]: 'Método de devolución',
    [routes.exchangeAddressPage]: 'Dirección de envío',
    [routes.refundSelectionPage]: 'Elige tu reembolso',
    [routes.verifyEmailPage]: 'Transferencia instantánea',
    [routes.summaryPage]: 'Resumen final',
    [routes.processCompletedPage]: null,
    [routes.successPage.replace(':orderId', orderId).replace(':returnId', returnId)]: null,
  }

  for (const key in cardTitleByPathName) {
    if (pathName.includes(key)) {
      return cardTitleByPathName[key]
    }
  }
}

export const getCardPropsByPathName = ({ location, orderInfo, merchantInfo, orderRecovery }) => {
  return {
    backLink: getBackLinkByPathName({ location, merchantInfo, orderInfo, orderRecovery }),
    cardTitle: getCardTitleByPathName({
      pathName: location.pathname,
      orderId: orderInfo.orderId,
      returnId: orderInfo.refundId,
    }),
    activeStep: getActiveStepByPathName({
      pathName: location.pathname,
      orderType: orderInfo.type,
      portalType: merchantInfo.preferences.portal_type,
      orderId: orderInfo.orderId,
      returnId: orderInfo.returnId,
      isRefundStepSkipped: orderInfo.isRefundStepSkipped,
    }),
  }
}
